import React, { useState, useEffect } from 'react';
import './Kite.css';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { CloudfrontVideoFormat } from '../../../videos/CloudfrontVideoFormat';

/**
 * Plays the celebrate video module shown at the end of each day
 * @param {*} props
 * @returns the HTML code for the celebrate module
 */
export default function KiteLearn(props) {
  // Initialize variables to be used later

  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const dispatch = useDispatch();
  const [kites, setKites] = useState(true);
  const [kite1, setKite1] = useState(true);
  const [kite2, setKite2] = useState(false);
  const [kite3, setKite3] = useState(false);
  const [effect1, setEffect1] = useState('bounceIcons');
  const [effect2, setEffect2] = useState('');
  const [effect3, setEffect3] = useState('');
  const [displayLearnVideo, setDisplayLearnVideo] = useState(false);
  const [kiteNum, setKiteNum] = useState(0);
  const [learnVideo, setlearnVideo] = useState('');
  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

  const bounceSound = new Audio(generateImageUrl('media/Module1Videos/button_bouncing.mp3'));
  const touchSound = new Audio(generateImageUrl('media/Module1Videos/touch_button.mp3'));
  const kite1Img = generateImageUrl('images/Module17Images/Kite+1.svg');
  const kite2Img = generateImageUrl('images/Module17Images/Kite+2.svg');
  const kite3Img = generateImageUrl('images/Module17Images/Kite+3.svg');
  const [Exit, setExit] = useState(generateImageUrl('images/Images/close.png'));

  // CSS code for the back button


  const displayVideo = (video, num) => {
    setlearnVideo(video);
    setKiteNum(num);
    setKites(false);
    setDisplayLearnVideo(true);
  };

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  useEffect(() => {
    sleep(700).then(() => {
      bounceSound.play()
    });
  }, []);

  // The actual HTML code that determines whether to show the module above.
  return (
    <>
      <div
        className='kiteScene'
        style={{ backgroundImage: `url(${props.background})` }}
      >
        <img
          className='back-btn-ftb'
          src={Exit}
          onClick={() => {
            props.setDisplayLearn(false);
          }}
        ></img>
        {displayLearnVideo && (
          <CloudfrontVideoFormat
            source={learnVideo}
            back={'unit4'}
            background={props.background}
            close={()=>{setDisplayLearnVideo(false); setKites(true);}}
            ended={() => {
              setDisplayLearnVideo(false);
              setKites(true);
              if (kiteNum === 1) {
                setEffect1('');
                setEffect2('bounceIcons');
                setKite2(true);
                sleep(700).then(() => {
                  bounceSound.play()
                });
              } else if (kiteNum === 2) {
                setEffect2('');
                setEffect3('bounceIcons');
                setKite3(true);
                sleep(700).then(() => {
                  bounceSound.play()
                });
              } else if (kiteNum === 3) {
                if (props.module.reviewIcon === false) {
                  dispatch({ type: props.step_completed, payload: 'learn' });
                }
                props.module.sectionCompleted = props.module.sectionCompleted + 1
                props.setDisplayLearn(false);
              }
            }}
          />
        )}
        {kites && (
          <div className='dog_kite'>
            {(
              <div
                className='kite1'
                style={kite1 ? {} : { opacity: 0, pointerEvents: 'none' }}
                onClick={() => {
                  touchSound.play()
                  sleep(500).then(() => {
                    displayVideo(props.learnVideo1, 1);
                  });
                }}
              >
                <img alt='' className='kite1' id={effect1} src={kite1Img} />
              </div>
            )}
            {(
              <div
                className='kite2'
                style={kite2 ? {} : { opacity: 0, pointerEvents: 'none' }}
                onClick={() => {
                  touchSound.play()
                  sleep(500).then(() => {
                    displayVideo(props.learnVideo2, 2);
                  });
                }}
              >
                <img alt='' className='kite2' id={effect2} src={kite2Img} />
              </div>
            )}
            {(
              <div
                className='kite3'
                style={kite3 ? {} : { opacity: 0, pointerEvents: 'none' }}
                onClick={() => {
                  touchSound.play()
                  sleep(500).then(() => {
                    displayVideo(props.learnVideo3, 3);
                  });
                }}
              >
                <img alt='' className='kite3' id={effect3} src={kite3Img} />
              </div>
            )}
            {<img alt='' className='animateDog' src={props.animal} />}
          </div>
        )}
      </div>
    </>
  );
}
